import React from 'react';
import "@vapi-ai/web";
import VapiWidgetComponent from '../components/VapiWidgetComponent';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Features from '../components/Features';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

function Home() {
    return (
        <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
            <Hero />
            <Services />
            <Features />
            <CTA />
            <Footer />
            <VapiWidgetComponent />
        </div>
    )
}

export default Home